import { useState, useEffect } from 'react';

const STORAGE_PRODUCT_KEY = 'productFilter';

export const productsBase = { sort: "Name", sortOrder: "ASC", result: [], pages: [], totalPages: 0, totalCount: 0, page: 1, pageSize: 30 };

export function UseProductFilter() {
  const [filter, setFilter] = useState({
    sort: productsBase.sort,
    sortOrder: productsBase.sortOrder,
    page: productsBase.page,
    pageSize: productsBase.pageSize,
    radius: [],
    wall: [],
    diameter: [],
    categories: [],
    brand: []
  });

  useEffect(() => {
    const storedProductFilter = localStorage.getItem(STORAGE_PRODUCT_KEY);
    if (storedProductFilter) {
      try {
        const parsed = JSON.parse(storedProductFilter);
        // Backfill array fields when an older cached schema is missing them —
        // the BFF NullRefs on `foreach (item in categories)` otherwise.
        setFilter({
          sort: parsed.sort || productsBase.sort,
          sortOrder: parsed.sortOrder || productsBase.sortOrder,
          page: parsed.page || productsBase.page,
          pageSize: parsed.pageSize || productsBase.pageSize,
          radius: Array.isArray(parsed.radius) ? parsed.radius : [],
          wall: Array.isArray(parsed.wall) ? parsed.wall : [],
          diameter: Array.isArray(parsed.diameter) ? parsed.diameter : [],
          categories: Array.isArray(parsed.categories) ? parsed.categories : [],
          brand: Array.isArray(parsed.brand) ? parsed.brand : [],
        });
      } catch (_) {
        localStorage.removeItem(STORAGE_PRODUCT_KEY);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_PRODUCT_KEY, JSON.stringify(filter));
  }, [filter]);

  return [filter, setFilter];
}

